"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionsListsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.SanctionsListsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.sanctions_lists.label',
    fallbackLabel: 'Sanctions lists',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'UN_LIST', label: 'fields.enm.sanctions_lists.options.UN_LIST', fallbackLabel: 'United Nations Security Council Consolidated List (UN List)' },
        { key: 'EU_LIST', label: 'fields.enm.sanctions_lists.options.EU_LIST', fallbackLabel: 'Consolidated list of persons, groups and entities subject to EU financial sanctions (EU List)' },
        { key: 'OFAC_LIST', label: 'fields.enm.sanctions_lists.options.OFAC_LIST', fallbackLabel: 'Specially designated Nationals and Blocked Persons (SDN List), Consolidated Sanctions List (Non-SDN List), by the US Office of Foreign Assets Control (OFAC)' },
        { key: 'HMT_LIST', label: 'fields.enm.sanctions_lists.options.HMT_LIST', fallbackLabel: 'HMT List (only applicable if business is performed in the UK)' },
        { key: 'ADDITIONAL_AUTONOMOUS_LISTS', label: 'fields.enm.sanctions_lists.options.ADDITIONAL_AUTONOMOUS_LISTS', fallbackLabel: 'Additional autonomous lists not listed above' },
        { key: 'NONE', label: 'fields.enm.sanctions_lists.options.NONE', fallbackLabel: 'None of the above' },
    ],
    trackFieldValueWithAnalytics: false,
};
